import { STORAGE_TOKEN } from "../../constants/localstorage";
import { ROUTE_LOGIN_NICKNAME } from "../../constants/routes";
import { memoryHistory } from "../../index";
import { logIn } from "../../libs/auth";
import { setStorage } from "../../libs/storage";
import { UserVerifyResponse } from "../../proto/UserVerify_pb";
import BaseHandler from "../BaseHandler";
import Metrix from "../../libs/metrix";
import { METRIX_REGISTER_USER } from "../../constants/events";

export default class HandleUserVerifyResponse extends BaseHandler<UserVerifyResponse> {
  handle() {
    const userVerifyResponse = this.response.toObject();
    setStorage(STORAGE_TOKEN, userVerifyResponse.token);

    if (userVerifyResponse.newUser) {
      memoryHistory.push({ pathname: ROUTE_LOGIN_NICKNAME }, { isSafe: true });
    } else {
      Metrix.sendEvent(METRIX_REGISTER_USER);
      logIn();
    }
  }
}
